'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './community-edit.routes';

export class CommunityEditComponent {
  constructor(Auth, $state, $stateParams, dialogs, CommunityService, SettingsService, $uibModal) {
    'ngInject';

    this.communityId = $stateParams.id;

    this.dialogs = dialogs;
    this.CommunityService = CommunityService;
    this.SettingsService = SettingsService;
    this.$uibModal = $uibModal;
    this.Auth = Auth;

    this.activationTypes = [{
      type: "initial",
      name: "Initial Password"
    }, {
      type: "invitation",
      name: "Invitation"
    }];

    this.SettingsService.getByName({name: 'config.app'}, appSettings => {
      this.phoneTypes = appSettings.data.phoneTypes;
      this.mailTypes = appSettings.data.mailTypes;
      this.addressTypes = appSettings.data.addressTypes;
      this.socialTypes = appSettings.data.socialTypes;
      this.webAccessGroupConfig = [{
        "name": "- None -",
        "website": "",
        "code": "",
        "roles": []
      }];
      if (appSettings.data.webAccessGroupConfig) {
        appSettings.data.webAccessGroupConfig.forEach(gcfg => {
          this.webAccessGroupConfig.push(gcfg);
        })
      }
    });

    this.SettingsService.getByName({name: 'custom-fields'}, customFieldSettings => {
      if (customFieldSettings.data.hasOwnProperty("community")) {
        this.customSchema = customFieldSettings.data.community;
        this.customForm = ["*"];
      }
    });

    this.jsonValue = "";
    this.$state = $state;


    this.model = {
      phone: [],
      email: [],
      web: [],
      address: [],
      webAccess: {}
    };

    if (this.communityId) {
      this.CommunityService.get({id: this.communityId}, data => {
        this.model = data;
        this.customFields = this.model.customFields || {};
      }, err => {
        console.log('Could not load community data from server');
      })
    }
  }

  getRolesByCode(code) {
    let selected = this.webAccessGroupConfig.find(gc => gc.code == code);
    if (selected) {
      return selected.roles;
    }
  }

  removeProfilePicture() {
    this.model.profilePicture = null;
  }

  openAssetUploadModal() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'assetUpload',
      resolve: {
        config: function() {
          return {
            acceptedFileTypes: 'image/*'
          }
        }
      }
    });

    modalInstance.result.then(
      function (result) {

        if (result && result.length > 0) {
          that.model.profilePicture = result[0];
        }

      },
      function () { /* cancel */ }
    );

  }

  create(form) {
    this.submitted = true;
    this.sendFailure = false;

    var that = this;

    if (form.$valid) {

      var onSuccess = () => {
        var actionString = (this.communityId) ? "changed" : "created";
        var dlg = this.dialogs.notify("Success", "The community has been "+actionString+" successfully");
        dlg.result.then(() => {
          that.$state.go("community-list");
        });
      };

      var onError = err => {
        this.sendFailure = true;
      };

      this.model.customFields = this.customFields || {};

      if (this.communityId) {  // Save changes on the current settings
        this.CommunityService.update({id: this.communityId}, this.model, onSuccess, onError);
      } else { // Create new settings
        this.model.meta = {creationUser: this.Auth.getCurrentUserSync()._id};
        this.CommunityService.save(this.model, onSuccess, onError);
      }
    }
  }

  addressEdit(idx, address) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'addressEdit',
      resolve: {
        config: function() {
          return {
            data: address
          }
        }
      },
      size: 'md'
    });

    modalInstance.result.then(
      function (address) {

        that.model.address[idx] = address;

      },
      function () { /* cancel */ }
    );

  }

  updatePrimaryPhone(idx) {
    angular.forEach(this.model.phone, (phone, index) => {
      phone.isPrimary = (idx == index);
    });
  }

  addPhone() {
    this.model.phone.push({
      type: this.phoneTypes[0],
      number: '',
      isPrimary: !this.model.phone.length
    })
  }

  removePhone(idx) {
    // Check if the removed phone was the primary one
    let primaryRemoved = this.model.phone[idx].isPrimary;

    // remove the phone
    this.model.phone.splice(idx,1);

    // if the feature image is removed and there are still images in the gallery,
    // set the feature image to the first image in the gallery
    if (primaryRemoved && this.model.phone.length > 0) {
      this.model.phone[0].isPrimary = true;
    }
  }

  addSocial() {
    this.model.web.push({
      type: this.socialTypes[0],
      link: ''
    })
  }

  removeSocial(idx) {
    // remove the phone
    this.model.web.splice(idx,1);

  }

  updatePrimaryEmail(idx) {
    angular.forEach(this.model.email, (email, index) => {
      email.isPrimary = (idx == index);
    });
  }

  addEmail() {
    this.model.email.push({
      type: this.phoneTypes[0],
      address: '',
      isPrimary: !this.model.email.length
    })
  }

  removeEmail(idx) {
    // Check if the removed phone was the primary one
    let primaryRemoved = this.model.email[idx].isPrimary;

    // remove the phone
    this.model.email.splice(idx,1);

    // if the feature image is removed and there are still images in the gallery,
    // set the feature image to the first image in the gallery
    if (primaryRemoved && this.model.email.length > 0) {
      this.model.email[0].isPrimary = true;
    }
  }

  updatePrimaryAddress(idx) {
    angular.forEach(this.model.address, (address, index) => {
      address.isPrimary = (idx == index);
    });
  }

  addAddress() {
    let idx = this.model.address.length;
    this.addressEdit(idx, {
      type: this.phoneTypes[0],
      state: 'FL',
      isPrimary: !idx
    });
  }

  removeAddress(idx) {
    // Check if the removed address was the primary one
    let primaryRemoved = this.model.address[idx].isPrimary;

    // remove the address
    this.model.address.splice(idx,1);

    // if the feature image is removed and there are still images in the gallery,
    // set the feature image to the first image in the gallery
    if (primaryRemoved && this.model.address.length > 0) {
      this.model.address[0].isPrimary = true;
    }
  }
}

export default angular.module('conduu.communityEdit', [uiRouter])
  .config(routes)
  .component('communityEdit', {
    template: require('./community-edit.html'),
    controller: CommunityEditComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/portfolio/community-edit/community-edit.component.js